import React, { useEffect } from 'react'


export default ({ title, desc }) => {
    useEffect(() => {
        window.document.title = title || ""
    }, [title])

    return <>
        <meta name="description" content={desc || ""} />
        <meta name="og:title" content={title} />
    </>
}